<template>
  <a-form-item :label="field.name">
    <a-textarea
      placeholder="Nhập thông tin"
      :rows="4"
      :value="value"
      @change="onChange"
    />
  </a-form-item>
</template>
<script>
export default {
  props: {
    field: {
      type: Object,
      required: true,
    },
    value: String,
  },
  methods: {
    onChange(event) {
      this.$emit("input", event.target.value);
    },
  },
};
</script>
